import { useEffect, useState } from 'react'
import { useImmer } from 'use-immer'
import { Box, Button, Card, CardBody, CardHeader, Flex, FormControl, FormLabel, Heading, HStack, Input, VStack } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { useAppContext } from 'hooks/useAppContext'
import { getPedestalPricingConfig, setPedestalPricingConfig } from 'api'

const BreadcrumbNav = [
  {
    label: 'Pedestal Pricing',
    isCurrentPage: true
  }
]

export const PedestalPricingForm = () => {
  const { createToast } = useAppContext()
  const [form, setForm] = useImmer({
    pedestalBase: 0,
    pedestalPerSqin: 0,
    polecoverBase: 0,
    polecoverPerSqin: 0,
    pedestalskinsBase: 0,
    pedestalskinsPerSqin: 0
  })
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const response = await getPedestalPricingConfig()
        setForm(draft => {
          draft.pedestalBase = response.pedestalBase
          draft.pedestalPerSqin = response.pedestalPerSqin
          draft.polecoverBase = response.polecoverBase
          draft.polecoverPerSqin = response.polecoverPerSqin
          draft.pedestalskinsBase = response.pedestalskinsBase
          draft.pedestalskinsPerSqin = response.pedestalskinsPerSqin
        })
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsSaving(true)
    try {
      const response = await setPedestalPricingConfig({
        pedestalBase: form.pedestalBase,
        pedestalPerSqin: form.pedestalPerSqin,
        polecoverBase: form.polecoverBase,
        polecoverPerSqin: form.polecoverPerSqin,
        pedestalskinsBase: form.pedestalskinsBase,
        pedestalskinsPerSqin: form.pedestalskinsPerSqin
      })
      setForm(draft => {
        draft.pedestalBase = response.pedestalBase
        draft.pedestalPerSqin = response.pedestalPerSqin
        draft.polecoverBase = response.polecoverBase
        draft.polecoverPerSqin = response.polecoverPerSqin
        draft.pedestalskinsBase = response.pedestalskinsBase
        draft.pedestalskinsPerSqin = response.pedestalskinsPerSqin
      })
      createToast('success', 'Successfully updated.')
      setIsSaving(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSaving(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Pedestal Pricing</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Configuration</Heading>
          </CardHeader>
          <CardBody p={8}>
            <form onSubmit={handleSubmit}>
              <HStack gap={8} width="100%">
                <VStack gap={2} flex={1}>
                  <FormControl isRequired>
                    <FormLabel>Base Price (Pedestal)</FormLabel>
                    <Input type="number" name="pedestalBase" value={form.pedestalBase} onChange={handleChange} />
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Price Per Sqin (Pedestal)</FormLabel>
                    <Input type="number" name="pedestalPerSqin" value={form.pedestalPerSqin} onChange={handleChange} />
                  </FormControl>
                </VStack>
                <VStack gap={2} flex={1}>
                  <FormControl isRequired>
                    <FormLabel>Base Price (Pole Cover)</FormLabel>
                    <Input type="number" name="polecoverBase" value={form.polecoverBase} onChange={handleChange} />
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Price Per Sqin (Pole Cover)</FormLabel>
                    <Input type="number" name="polecoverPerSqin" value={form.polecoverPerSqin} onChange={handleChange} />
                  </FormControl>
                </VStack>
                <VStack gap={2} flex={1}>
                  <FormControl isRequired>
                    <FormLabel>Base Price (Pedestal Skins)</FormLabel>
                    <Input type="number" name="pedestalskinsBase" value={form.pedestalskinsBase} onChange={handleChange} />
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Price Per Sqin (Pedestal Skins)</FormLabel>
                    <Input type="number" name="pedestalskinsPerSqin" value={form.pedestalskinsPerSqin} onChange={handleChange} />
                  </FormControl>
                </VStack>
              </HStack>
              <Button type="submit" mt={8} colorScheme="blue" isLoading={isSaving}>Save</Button>
            </form>
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
